export default __webpack_public_path__ + "static/media/LYoutube.676c27b4.svg";